import React from "react";

const WhyFms = ({data}) => {
  // const data = [
  //   {
  //     id: 1,
  //     title: "Hassle-Free Maintenance Management",
  //     desc: "Track, assign, and resolve maintenance requests with real-time status updates—ensuring tenant satisfaction without the paperwork.",
  //     img: "/assets/Landlord/section1.png",
  //   },
  //   {
  //     id: 2,
  //     title: "Transparent Financial Tracking:",
  //     desc: "Monitor rent collection, pending dues, and overall revenue at a glance—so you never miss a payment or lose track of cash flow.",
  //     img: "/assets/Landlord/section2.png",
  //   },
  //   {
  //     id: 3,
  //     title: "All-in-One Control Panel:",
  //     desc: "FMS puts every essential tool—notifications, reports, broadcasts, and more—right at your fingertips.",
  //     img: "/assets/Landlord/section3.png",
  //   },
  // ];
  return (
    <div className="text-center">
      <h3 className="font-popinsBold mt-32 text-3xl md:text-4xl lg:text-6xl text-themeColor w-[90%] mx-auto md:w-full pb-5">
        Why FMS for <span className="text-btnColor">Landlords?</span>
      </h3>
      {data.map((item) => (
        <div
          key={item.id}
          className={`flex flex-col-reverse md:flex-row md:items-center ${item.id === 2 ? 'md:flex-row-reverse' : ''} justify-between w-[90%] xl:w-[85%] mx-auto`}
        >
          <div className="md:w-[49%] text-left">
            <h4 className="text-themeColor font-popinsBold text-2xl lg:text-3xl">
              {item.title}
            </h4>
            <p className="font-popinsMedium text-base md:text-lg lg:text-xl pt-3 pr-3">{item.desc}</p>
          </div>
          <div className="md:w-[49%] lg:bg-[#0381CA0F] rounded-xl lg:py-4">
            <img
              src={item.img}
              alt=""
              className="w-full h-[300px] object-contain"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default WhyFms;
